import {navigateTo} from '@typed-router';
import {storeToRefs} from 'pinia';
import {defineNuxtRouteMiddleware} from '#app';
import {resolveAllowedStepName} from '~/features/advanced-search/funnel/utils/resolveAllowedStep';
import {useAdvancedSearchStore} from '~/features/advanced-search/stores/advancedSearch.store';

export default defineNuxtRouteMiddleware((to) => {
    const advancedSearchStore = useAdvancedSearchStore();
    const {advancedSearch, funnelSteps} = storeToRefs(advancedSearchStore);

    if (!advancedSearch.value) {
        return;
    }

    if (to.name === 's-advanced-briefId-step') {
        const briefId = to.params.briefId as string;
        const currentStep = to.params.step as string;

        const allowedStep = resolveAllowedStepName(funnelSteps.value, currentStep, advancedSearch.value);

        if (currentStep !== allowedStep) {
            return navigateTo(
                {
                    name: 's-advanced-briefId-step',
                    params: {briefId, step: allowedStep},
                },
                {replace: true},
            );
        }
    }
});
